module.exports = __webpack_public_path__ + "static/media/logo.c2da19c4.png";